<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" width="600px">
            <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="cards"
                    dense
                    item-key="id"
                    :show-select="true"
                    :options.sync="options"
                    :page.sync="page"
                    :server-items-length="cards.length"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="{
                                  showFirstLastPage: true,
                                  'items-per-page-options': [5, 10, 15, 30],
                                  itemsPerPageText: 'Элементов на странице ',
                                  itemsPerPageAll: 'qwerty',
                                  showCurrentPage: false
                                }"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-row>
                            <v-col cols="4">
                                <v-select
                                        label="Категория"
                                        :items="categories"
                                        item-text="title"
                                        item-value="id"
                                        v-model="cardCategoryId"
                                        hide-details
                                />
                            </v-col>
                            <v-col cols="5">
                                <v-select
                                        label="Группа"
                                        :items="cardLists"
                                        item-text="title"
                                        item-value="id"
                                        v-model="cardListId"
                                        hide-details
                                />
                            </v-col>
                            <v-col cols="1">
                                <v-btn small title="Добавить выбранные элементы" @click="addSelected"><v-icon>add</v-icon></v-btn>
                            </v-col>
                            <v-col cols="1">
                                <v-btn small title="Очистить выбор" @click="clearSelected">
                                    <v-icon>clear</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-toolbar>
                </template>
                <template v-slot:item.count="{ item }">
                    <v-text-field v-model="item.count" type="number"/>
                </template>
            </v-data-table>
        </v-dialog>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'CardSelectBox',
    props: { dialog: Boolean },
    data() {
        return {
            headers: [
                {
                    text: 'id',
                    align: 'left',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Название',
                    align: 'left',
                    sortable: false,
                    value: 'title'
                },
                {
                    text: 'Количество',
                    align: 'left',
                    sortable: false,
                    value: 'count',
                    width: 20
                }
            ],
            cardCategoryId: null,
            show: false,
            options: { itemsPerPage: 15 },
            page: 1,
            totalClients: 0,
            loading: false,
            countClients: 1,
            cardLists: [],
            cardListId: null,
            selected: [],
            cards: []
        }
    },
    computed: {
        ...mapGetters({
            categories: 'cards/cardCategories',
            lastLoadedCategoryId: 'cards/lastLoadedCategoryId',
            cardsInStore: 'cards/cards'
        })
    },
    watch: {
        dialog(value) { this.show = value },
        show() {
            if (this.show === false) {
                this.$emit('close')
            } else {
                this.cardListId = null
                this.cards = []
                this.selected = []
                // this.loadModel(this.editCardId)
            }
        },
        cardCategoryId(value) {
            if (value !== this.lastLoadedCategoryId) {
                this.$store.dispatch('cards/cardListAllByCategoryReturnOnly', value).then(response => {
                    if (response.ok) {
                        this.cardLists = response.response.data
                    }
                })
            } else {
                this.cardLists = this.$store.getters['cards/cardLists'].slice()
            }
        },
        cardListId(value) {
            if (value != null) {
                if (this.cardCategoryId !== this.lastLoadedCategoryId) {
                    this.$store.dispatch('cards/cardAllByCardListReturnOnly', value).then(response => {
                        if (response.ok) {
                            this.cards = response.response.data
                        }
                    })
                } else {
                    this.cards = this._.cloneDeep(this.$store.getters['cards/cards'].filter(card => card.card_list_id === value))
                }
            }
        }
    },
    methods: {
        addSelected() {
            let elements = []
            this.selected.forEach((item) => {
                elements.push([item.id, +item.count])
                let index = this.cardsInStore.find(card => card.id === item.id)
                if (index !== -1) {
                    this.$store.dispatch('cards/addCard', this._.cloneDeep(item))
                }
            })
            this.$emit('addCards', elements)
            this.clearSelected()
        },
        clearSelected() {
            this.selected = []
        }
    }
}
</script>

<style scoped>

</style>
